import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_CHART_CONFIG, MISSING_DATA_CONFIG, SUMMARY_BAND_CONFIG } from "@nexus/widget-kit";

/** What an author sets on the CDN/SA daily trend. */
export const settings = defineWidgetSettings({
  id: "cdnsa-daily-trend",
  extends: [SUMMARY_BAND_CONFIG, MISSING_DATA_CONFIG, ANIMATE_CHART_CONFIG],
  properties: {
    showNewAccounts: {
      type: "boolean",
      title: "New accounts",
      default: false,
      "x-ui": { category: "display", group: "show", order: 10 },
    },
  },
});
